<template>
	<div data-tour-scope="warehouse-inventory">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search" dense></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.warehouse.home') }} / {{ this.$vuetify.lang.t('$vuetify.front.warehouse.inventory') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
									<v-icon left>mdi-school-outline</v-icon>
									Tutorial guidato
								</v-btn>

							<v-spacer></v-spacer>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->

								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
								<v-btn text data-tour="delete" @click="deleteItemInventory">
									<v-icon>mdi-trash-can-outline</v-icon>
								</v-btn>
								<v-btn text data-tour="confirm" @click="confirmItemInventory">
									<v-icon>mdi-swap-horizontal</v-icon>
								</v-btn>

								<!-- <v-divider vertical></v-divider>-->
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<!--<v-list-item @click="getCategoryMagento" v-if="magento">
                                            <v-list-item-icon>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title>Importa da Magento</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>-->

										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Aggiungi prodotto</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<!--@click="getItemsShopifyAz"-->
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>
						<v-toolbar flat class="border_bottom">
							<v-menu bottom v-model="menu" :close-on-content-click="false">
								<template #activator="{ on, attrs }">
									<v-btn text v-bind="attrs" v-on="on" style="text-transform: none"><v-icon>mdi-filter</v-icon> Aggiungi filtro </v-btn>
								</template>
								<v-card>
									<v-list dense>
										<v-list-item>
											<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
										</v-list-item>
									</v-list>
									<v-card-actions>
										<v-spacer></v-spacer>

										<v-btn text @click="menu = false"> Cancella </v-btn>
										<v-btn color="primary" text @click="confirmFilter()"> Conferma </v-btn>
									</v-card-actions>
								</v-card>
							</v-menu>
							<v-chip v-if="searchfield" class="ma-2" close @click:close="deleteChip('search', searchfield)"><b class="mr-1">Ricerca</b> {{ searchfield }} </v-chip>
							<!--							<v-btn text @click="toggleDrawerFilter" style="text-transform: none"> Aggiungi filtro </v-btn>-->
						</v-toolbar>
						<v-row class="pr-2 pl-2">
							<v-col cols="12" sm="4" data-tour="app">
								<img :src="require(`@/assets/images/qrcode.png`)" width="200" />
								<img :src="require(`@/assets/images/android.svg`)" width="200" />
							</v-col>
							<v-col cols="12" sm="8" data-tour="scan">
								<v-alert outlined text type="info"> Usare il lettore barcode per leggere i codici dei prodotti </v-alert>

								<v-text-field hide-details="auto" readonly outlined append-icon="mdi-barcode" v-model="sku"></v-text-field>
								<qr-scan-panel class="mt-2 mb-2" data-tour="phone" @code="processScan" />
							</v-col>
						</v-row>
						<div v-if="getElement.length === 0 && this.sku != ''">
							<v-container>
								<v-alert outlined text type="error"> Nessun prodotto trovato per questo codice</v-alert>
							</v-container>
						</div>
						<!-- telefono: ogni prodotto trovato dalla lettura diventa una card con il conteggio -->
						<div v-if="getElement.length > 0 && mobileCards" data-tour="count" class="kv-list px-3 pb-3">
							<key-value-card v-for="item in getElement" :key="item.name" :title="item.trans.name" :image="getImage(item) || ''" :fields="campiLettura(item)">
								<template v-if="item.variants?.variants?.length > 0" v-slot:top>
									<div class="mb-1">
										<v-chip v-for="el in item.variants.variants" :key="el._id" :ripple="false" class="mr-2 mb-2" small>
											<b class="mr-2">{{ el.name.trans }}</b> {{ el.value.trans }}
										</v-chip>
									</div>
								</template>
								<v-text-field outlined dense hide-details v-model="item.variants.qt" label="Quantità in magazzino"></v-text-field>
								<v-btn block large color="success" dark class="mt-3" @click="updateinventory(item)"> CONFERMA</v-btn>
							</key-value-card>
						</div>
						<v-simple-table key="table-branch-1" v-else-if="getElement.length > 0" data-tour="count">
							<thead>
								<tr>
									<th class="text-left">Image</th>
									<th class="text-left">Name</th>
									<th class="text-left">Variante</th>
									<th class="text-left">Qt x unità</th>
									<th class="text-left">Quantità</th>
									<th class="text-left">Azione</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in getElement" :key="item.name">
									<td>
										<template v-if="getImage(item)">
											<img :src="getImage(item)" style="height: 100px" />
										</template>
									</td>
									<td>
										<span>{{ item.trans.name }}</span
										><br />
										<small>{{ item?.variants?.sku ? 'SKU: ' + item?.variants?.sku + ' - ' : '' }} {{ item?.variants?.sku ? 'EAN: ' + item?.variants?.ean : '' }}</small>
									</td>
									<td>
										<v-chip v-for="el in item.variants?.variants" v-if="item.variants?.variants?.length > 0" :key="el._id" :ripple="false" class="mr-2 mb-2" small>
											<b class="mr-2">{{ el.name.trans }}</b> {{ el.value.trans }}
										</v-chip>
									</td>
									<td>{{ item?.variants?.qtunit }}</td>
									<td><v-text-field hide-details="auto" outlined v-model="item.variants.qt" label="Quantità in magazzino" class="mt-5"></v-text-field></td>
									<td>
										<p>
											<v-btn x-large color="success" dark class="mt-3" @click="updateinventory(item)"> CONFERMA</v-btn>
										</p>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
						<v-data-table
							data-tour="list"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							@input="toggle"
							class="elevation-0"
							:mobile-breakpoint="0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="inventory-cards">
									<tr v-for="(item, index) in items" :key="item._id || index">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name" :image="createImage(item)" :image-fallback="immagineSegnaposto" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary">
																<v-icon> mdi-dots-vertical </v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<v-text-field v-model="item.qt" data-tour="row-qt" label="Qt" type="number" outlined dense hide-details append-icon="mdi-content-save-outline " @click:append="saveQt(item)" />
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="index">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>

										<td>
											{{ item.created_at | moment('DD/MM/YYYY') }}
										</td>

										<td>
											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>

											<!---->
										</td>
										<td>{{ item.brand }}</td>
										<td>{{ item.category }}</td>
										<td>{{ item.model }}</td>
										<td>{{ item.name }}</td>
										<td>{{ item.variant }}</td>
										<td>{{ item.sku }}</td>
										<td>{{ item.supplier }}</td>
										<td>{{ item.ean }}</td>
										<td>
											<v-text-field hide-details="auto" v-model="item.qt" data-tour="row-qt" label="Qt" type="number" append-icon="mdi-content-save-outline " @click:append="saveQt(item)" />
											<!--											<template v-slot:append-outer>
												<v-btn icon @click="createSellerSkuCreated()">
													<v-icon color="primary" class="mr-1"> mdi-barcode-scan </v-icon>
												</v-btn>
											</template>
											</v-text-field>-->
										</td>

										<!--td>{{ item.id }}</td-->
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Il prodotto verrà eliminato solo dalla lista dell'inventario ma non nel catalogo dei prodotti </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmdelete" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione l'inventario sarà cancellato </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmdelete = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDeleteInventario"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogconfirmImport" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione i prodotti verranno aggiornati e l'inventario sarà confermato </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirmImport = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmImportInventario"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import axios from 'axios';

Vue.use(VuetifyDraggableTreeview);

const FormCreate = () => import('@/components/inventories/Create.vue');

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import QrScanPanel from '@/components/warehouse/QrScanPanel.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createWarehouseInventoryTourSteps } from './warehouse-inventory-tour';

export default {
	name: 'Inventories',
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createWarehouseInventoryTourSteps()),
		};
	},
	data() {
		return {
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					categories: [],
					brand: [],
					variants: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: '', value: '' },

				{ text: 'Creazione', value: 'created_at', sortable: true },
				{ text: 'Immagine', value: 'image', sortable: false },
				{ text: 'Brand', value: 'brand', sortable: false },
				{ text: 'Categoria', value: 'category', sortable: false },
				{ text: 'Modello', value: 'model' },
				{ text: 'Nome', value: 'name' },
				{ text: 'Variante', value: 'variant', sortable: false },
				{ text: 'Sku', value: 'sku' },
				{ text: 'Supplier', value: 'supplier' },
				{ text: 'Ean', value: 'ean' },
				{ text: 'Quantità', value: 'qt' },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmdelete: false,
			dialogconfirmImport: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			selectVariants: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			magento: false,
			shopify: false,
			fattureincloud: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			menu: false,
			sku: '',
			code: '',
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/items/download`;
		await this.fetchSetting();

		let promises = [];
		promises.push(this.fetchSetting());
		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;

		this.fetchSelect({}).then(result => {
			this.brands = result.data;
		});
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		'settings.options': {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;

				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormCreate,
		TourOverlay,
		QrScanPanel,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		selectedLength() {
			return this.selected.length;
		},
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// immagine di ripiego per la card quando quella del prodotto non si carica
		immagineSegnaposto() {
			return require(`@/assets/images/picture.svg`);
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'inventories/getIndex',
			getItems: 'inventories/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'inventories/getSortBy',
			getSortDesc: 'inventories/getSortDesc',
			getCategoriesTree: 'categories/getCategoriesTree',
			getCategoriesChildrean: 'categories/getCategoriesChildrean',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
			getElement: 'warehouse/getItems',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'inventories/setItems',
			setItem: 'inventories/setItem',
			setIndex: 'inventories/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setElement: 'warehouse/setItems',
		}),
		...mapActions({
			fetchItems: 'inventories/asyncFetchData',
			deleteItems: 'inventories/deleteItems',
			deleteInventory: 'inventories/deleteInventory',
			confirmInventory: 'inventories/confirmInventory',
			updateItems: 'inventories/updateItems',
			destroyData: 'inventories/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			fetchLists: 'brands/fetchLists',
			fetchSelect: 'brands/fetchSelect',
			setUpdateStatusItem: 'inventories/setUpdateStatusItem',
			setUpdateStatusItemVariant: 'inventories/setUpdateStatusItemVariant',
			fetchService: 'services/getServiceFetch',
			fetchServiceactive: 'services/getServiceFetchActive',
			getWarehouse: 'warehouse/getDetailSingle',
			saveInventory: 'warehouse/saveInventory',
			//'resetMessages' : 'settings/resetMessages'
		}),
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				let re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},
		async onKeypress(event) {
			if (event.keyCode === 13) {
				await this.processScan(this.code);
			} else {
				this.sku = '';
				this.code += event.key;
			}
		},

		// Unico punto di ingresso dei codici letti: pistola USB (Invio) e telefono (QrScanPanel).
		async processScan(code) {
			this.code = code;
			await this.setPreload(true);
			await this.getWarehouse({ search: this.code });
			this.sku = this.code;
			this.code = '';
			await this.setPreload(false);
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		imageUrlAlt(index) {
			// console.log("E",require(`@/assets/images/picture.svg`))
			//  console.log("EVENT",event)
			//   event.target.src = require(`@/assets/images/picture.svg`)
			//console.log(this.$refs[index])
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},
		filterCheck(event) {
			this.settings.filters.categories = _.map(event, '_id');
		},
		createImage(item) {
			let image = '';

			try {
				if (item?.image) {
					image = item.image;
				} else {
					throw 'no image';
				}

				return image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		download() {
			return (
				'nocors/items/download?token=' +
				this.getToken +
				'&search=' +
				this.searchfield +
				'&categories=' +
				this.settings.filters.categories +
				'&brands=' +
				this.settings.filters.brands +
				'&selected=' +
				this.selected
			);
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},
		changeFlag(item, color) {
			let url = 'items/update-flag';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getItems.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, color: color }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getItems[this.editIndex], { Color: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		changeStatus(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItem({
					_id: item._id,
					id: item.id,
					is_active: item.is_active,
				}).then(() => {
					//this.total = result.total
					//this.items = result.data.data
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
						this.setPreload(false);
					});
					/*if (result.data.data.ok) {
                            this.snackbar.color = "success";
                            this.snackbar.text = "Update successfully";
                            this.snackbar.snackbar = true;
                            this.snackbar.mode = 'multi-line';
                            this.snackbar.timeout = 5000;
                        }*/
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},
		changeStatusVariant(item) {
			try {
				this.setPreload(true);

				this.setUpdateStatusItemVariant({
					_id: item._id,
					id: item.id,
					variants: item.variants._id,
					active: item.variants.active,
				}).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getCategoryMagento() {
			this.setPreload(true);
			await this.getFetchCategoryMagento();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'Le categorie verranno caricate in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		/*async getItemsShopifyAz() {
			this.dialogconfirmImport = false;
			this.setPreload(true);
			await this.getItemShopify();
			this.setPreload(false);
			this.getDataFromApi();
			this.snackbar.color = 'success';
			this.snackbar.text = 'I prodotti saranno caricati in pochi secondi';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},*/
		async duplicateItem(key) {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormDuplicate';
			let item;
			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			/* let item = _.find(this.getItems, search => {
                    return search._id == this.selected[0]
                })*/
			this.setIndex(this.getItems.indexOf(item));
			this.setItem(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async editItem(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			this.setClearError({});
			this.operation = 'FormEdit';

			this.setIndex(this.getItems.indexOf(item));
			this.setItem(item);
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async getFileCategories() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormFile';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text) {
			this.setPreload(true);
			this.getDataFromApi().then(() => {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.selected = [];
				this.selectedall = [];
				this.setPreload(false);
			});
			/*this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;*/
			this.operation = '';
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;
				//this.items = result.data.data
				this.setPreload(false);
				this.selected = [];
				this.selectedall = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async saveQt(item) {
			let payload = this.form;
			try {
				this.setPreload(true);

				await this.updateItems(item);

				this.getDataFromApi().then(() => {
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.setPreload(false);
				});
			} catch (err) {
				this.setPreload(false);
				console.log(err);
			}
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},
		async confirmFilter() {
			this.menu = false;
			await this.getDataFromApi();
		},
		async updateinventory(item) {
			await this.setPreload(true);
			await this.saveInventory({ payload: item });
			await this.getDataFromApi();
			this.code = '';
			this.sku = '';
			await this.setPreload(false);
		},
		async deleteChip(type, value) {
			switch (type) {
				case 'search':
					this.searchfield = '';
					this.settings.search = '';
					this.settings.options.page = 1;
					break;
			}
			await this.getDataFromApi();
		},
		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},
		deleteItemInventory(item) {
			this.dialogconfirmdelete = true;
			this.form = item;
		},
		confirmItemInventory() {
			this.dialogconfirmImport = true;
		},

		confirmDelete() {
			this.dialogconfirm = false;

			this.deleteItems(this.form)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
		confirmDeleteInventario() {
			this.dialogconfirmdelete = false;

			this.deleteInventory()
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
		confirmImportInventario() {
			this.dialogconfirmImport = false;

			this.confirmInventory()
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedall = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
		},

		// coppie chiave/valore della card del prodotto letto dal barcode
		campiLettura(item) {
			return [
				{ label: 'SKU', value: item?.variants?.sku },
				{ label: 'EAN', value: item?.variants?.ean },
				{ label: 'Qt x unità', value: item?.variants?.qtunit },
			];
		},
		// coppie chiave/valore della card di una riga dell'inventario
		campiCard(item) {
			return [
				{ label: 'Creazione', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Brand', value: item.brand },
				{ label: 'Categoria', value: item.category },
				{ label: 'Modello', value: item.model },
				{ label: 'Variante', value: item.variant },
				{ label: 'Sku', value: item.sku },
				{ label: 'Supplier', value: item.supplier },
				{ label: 'Ean', value: item.ean },
			];
		},

		getImage(item) {
			let variant_id = item.variants?._id;
			if (variant_id) {
				let variant_ids = item.variants?.variants.map(item => item._id);
				let image = item.images.find(el => el.variants.includes(variant_id) || variant_ids.filter(item => el.variants.includes(item)).length > 0);
				if (image) {
					return image.sizes[0]?.value;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},

		//this.deleteCategories()
	},
	mounted() {
		this.setElement([]);
		document.addEventListener('keypress', this.onKeypress);
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		document.removeEventListener('keypress', this.onKeypress);
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style></style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.inventory-cards,
.inventory-cards tr {
	display: block;
	width: 100%;
}
.inventory-cards tr,
.inventory-cards tr:hover {
	background: transparent !important;
}
.inventory-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.inventory-cards tr:first-child td {
	padding-top: 12px !important;
}
.inventory-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.inventory-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
